module.exports = __webpack_public_path__ + "img/3.9c632ccb.png";